import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';

export default {
	validatePasswordResetAttempt({ commit }, formDetails) {
        var email = formDetails.email;
        var resetToken = formDetails.resetToken;
        // var password = formDetails.password;

        if(!email || !resetToken){
            commit('SET_RESET_PASSWORD_ERROR', "We couldn't find your account with that information");
            return;
        }
        
        // Retrieve Key
        var AuthKeyStore = require('../../../../common/utils/AuthKeyStore');
        var key = new AuthKeyStore().retrievePassword();
        var body = { 
            email : email,
            reset_token : resetToken
        };
        let url = process.env.MIX_API_URL + 'utility/password-reset-verify';
        var options = { headers : { SecretToken : key }};
        
        axios.post(url, body, options)
        .then(data => {
            return data
        })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if(!data || data.status != '200'){
                    throw new Error();
                }
                else{
                    commit('SET_RESET_PASSWORD_RESULT', data);
                }
            })
            .catch((err) => {
                var errorMessage = "We couldn't find your account with that information"
                var response = err.response
                if(response && response.data.message){
                    errorMessage = response.data.message
                }
                commit('SET_RESET_PASSWORD_RESULT', null);
                commit('SET_RESET_PASSWORD_ERROR', errorMessage);
            });
    },
    resetNewPassword({ commit }, formDetails) {
        var email = formDetails.email;
        var newpassword = formDetails.newpassword;
        if(!email || !newpassword){
            commit('SET_RESET_PASSWORD_ERROR', "We couldn't find your account with that information");
            return;
        }
        
        // Retrieve Key
        var AuthKeyStore = require('../../../../common/utils/AuthKeyStore');
        var key = new AuthKeyStore().retrievePassword();
        var body = { email, newpassword };
        let url = process.env.MIX_API_URL + 'utility/new-password';
        
        var options = { headers : { SecretToken : key }};
        
        axios.post(url, body, options)
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
            })
            .catch(err => {
                var errorMessage = "We couldn't find your account with that information"; // Default Message
                commit('SET_VALIDATE_EMAIL_RESULT', null);
                commit('SET_VALIDATE_EMAIL_ERROR', errorMessage);
            });
    },
    clearResetPasswordResult({commit}){
        commit('SET_RESET_PASSWORD_RESULT', null);
    },
    clearResetPasswordError({commit}){
        commit('SET_RESET_PASSWORD_ERROR', null);
    },
}